import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { SessionService } from '../services/session/session.service';
import { LoggerService } from '../services/logger/logger.service';

export const nonAuthGuard: CanActivateFn = () => {
  const logger = inject(LoggerService).for('NonAuthGuard');
  const session = inject(SessionService);
  const router = inject(Router);

  const toHome = () => {
    logger.debug({
      message: 'user is logged in, redirecting to home',
    });
    return router.createUrlTree(['/apps']);
  }

  if (!session.isResolving()) {
    logger.debug({
      message: 'session resolved, checking user',
    });
    return session.user() ? toHome() : true;
  }

  return toObservable(session.isResolving).pipe(
    filter((resolving) => !resolving),
    take(1),
    map(
      () => {
        logger.debug({
          message: 'session resolved, checking user',
        });
        return session.user() ? toHome() : true;
      }
    ),
  );
};
